import { FaultType } from 'shared/enums/fault-type';

type OrganisationTreeNode = {
  id: string;

  depth: number;

  parentId?: string;
  name: string;
  isLocation: boolean;
  isResidentialLocation: boolean;
  isDiversionChannel: boolean;
  isSubscriptionChannel: boolean;
  isHidden: boolean;
  hasAlternativeDiversionOrganisationUnits: boolean;
  hasAlternativeEmergencyAlarmRouteOrganisationUnits: boolean;
  hasEcdConnectorsInParent: boolean;
  faults: FaultType[];
  organisationUnitElectronicClientRecordLocationId?: string;
  parentOrganisationUnit?: OrganisationTreeNode;
  childOrganisationUnits: OrganisationTreeNode[];
  electronicClientRecordExistsRemotely?: boolean;
};

export default OrganisationTreeNode;

export const findUpstreamParentBranch = (
  rootNodes: OrganisationTreeNode | OrganisationTreeNode[],
  nodeId: string,
  upstream: OrganisationTreeNode[],
): OrganisationTreeNode[] | null => {
  if (!Array.isArray(rootNodes)) {
    return findUpstreamParentBranchForSingleNode(rootNodes, nodeId, upstream);
  }

  for (const rootNode of rootNodes) {
    const result = findUpstreamParentBranchForSingleNode(rootNode, nodeId, upstream);

    if (result) {
      return result;
    }
  }

  return null;
};

const findUpstreamParentBranchForSingleNode = (
  rootNode: OrganisationTreeNode,
  nodeId: string,
  upstream: OrganisationTreeNode[],
): OrganisationTreeNode[] | null => {
  const newUpstream = [...upstream, rootNode];

  if (rootNode.id === nodeId) {
    return newUpstream;
  }

  for (const childNode of rootNode.childOrganisationUnits) {
    const result = findUpstreamParentBranch([childNode], nodeId, newUpstream);
    if (result) {
      return result;
    }
  }

  return null;
};
